import React, {Component, useEffect, useState} from "react";
import classNames from "classnames/bind";
import styles from "./Footer.module.scss";
import {config} from "../../../config";
// import arrow_down_btn from "../../assets/icons/drop_down_icon.png"
// import arrow_up_btn from "../../assets/icons/drop_up_icon.png"

const cx = classNames.bind(styles);

export const Footer = () => {
    const [is_opened, setIsOpened] = useState(false)

    useEffect(() => {
        if (window.innerWidth >= 1230) {
            setIsOpened(true)
        }
    }, [])

    const toggleFooterDetail = () => {
        if (window.innerWidth < 1230) {
            setIsOpened(!is_opened)
        }
    }
    return (
        <footer className={cx("footer")}>
            <div className={cx("footer__wrap")}>
                <section className={cx("footer__menu")}>
                    <ul className={cx("footer__main")}>
                        <li className={cx("footer__main__item")}><a href="/" data-text="홈"
                                                                    className={cx("footer__main__link")}>홈</a></li>
                        <li className={cx("footer__main__item")}><a target="_blank" href="https://hanghae99.spartacodingclub.kr/"
                                                                    data-text="항해99"
                                                                    className={cx("footer__main__link")}>항해99</a></li>
                        <li className={cx("footer__main__item")}>
                            <a target="_blank" href={`${config.scc.url}/nb`}
                               data-text="국비지원교육" className={cx("footer__main__link")}>국비지원교육
                            </a>
                        </li>
                        <li className={cx("footer__main__item")}><a target="_blank" href={`${config.scc.url}/b2b`} data-text="기업교육"
                                                                    className={cx("footer__main__link")}>기업교육</a></li>
                    </ul>
                    {/*<ul className={cx("footer__sns")}>*/}
                    {/*    <li>*/}
                    {/*        <a*/}
                    {/*            target="_blank"*/}
                    {/*            href="https://m.blog.naver.com/PostList.nhn?blogId=spartacoding&categoryNo=6&logCode=0&categoryName=%EC%88%98%EA%B0%95%EC%83%9D%C2%A0%EC%86%94%EC%A7%81%ED%9B%84%EA%B8%B0"*/}
                    {/*            style={{*/}
                    {/*                // backgroundImage: `url(${require("/source/src/assets/icons/n_f_sns_naver.png")})`,*/}
                    {/*            }}*/}
                    {/*            className={cx("footer__sns__link")}*/}
                    {/*        >*/}
                    {/*            naver*/}
                    {/*        </a>*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <a*/}
                    {/*            target="_blank"*/}
                    {/*            href="https://spartacodingclub.tistory.com"*/}
                    {/*            style={{*/}
                    {/*                // backgroundImage: `url(${require("/source/src/assets/icons/n_f_sns_tistory.png")})`,*/}
                    {/*            }}*/}
                    {/*            className={cx("footer__sns__link")}*/}
                    {/*        >*/}
                    {/*            tistory*/}
                    {/*        </a>*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <a*/}
                    {/*            target="_blank"*/}
                    {/*            href="https://www.instagram.com/spartacodingclub"*/}
                    {/*            style={{*/}
                    {/*                // backgroundImage: `url(${require("/source/src/assets/icons/n_f_sns_insta.png")})`,*/}
                    {/*            }}*/}
                    {/*            className={cx("footer__sns__link")}*/}
                    {/*        >*/}
                    {/*            insta*/}
                    {/*        </a>*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <a*/}
                    {/*            target="_blank"*/}
                    {/*            href="https://www.youtube.com/channel/UC2Fh3XoQYNYTba-cigq5cAA"*/}
                    {/*            style={{*/}
                    {/*                // backgroundImage: `url(${require("/source/src/assets/icons/n_f_sns_youtube.png")})`,*/}
                    {/*            }}*/}
                    {/*            className={cx("footer__sns__link")}*/}
                    {/*        >*/}
                    {/*            youtube*/}
                    {/*        </a>*/}
                    {/*    </li>*/}
                    {/*</ul>*/}
                </section>
                <hr className={cx("footer__divider")}/>
                <section className={cx("footer__info")}>
                    <ul className={cx("footer__info__list")}>
                        <li className={cx("footer__info__list__item")}><a href="https://forms.gle/4kPLDbR8vVcvKVpd7"
                                                                          target="_blank" data-text="튜터 지원"
                                                                          className={cx("footer__info__link")}>튜터 지원</a>
                        </li>
                        <li className={cx("footer__info__list__item")}><a href="https://career.spartacodingclub.kr/"
                                                                          target="_blank" data-text="채용 안내"
                                                                          className={cx("footer__info__link")}>채용 안내</a>
                        </li>
                        <li className={cx("footer__info__list__item")}><a target="_blank" href="https://swjungle.net/"
                                                                          data-text="SW사관학교 정글"
                                                                          className={cx("footer__info__link")}>SW사관학교
                            정글</a></li>
                    </ul>
                    <ul className={cx("footer__info__list")}>
                        <li className={cx("footer__info__list__item")}><a target="_blank"
                                                                          href="https://teamsparta.notion.site/7b1dc644460946f08bab08b794de685f"
                                                                          data-text="개인정보처리방침"
                                                                          className={cx("footer__info__link")}>개인정보처리방침</a>
                        </li>
                        <li className={cx("footer__info__list__item")}><a target="_blank"
                                                                          href="https://www.notion.so/teamsparta/900680faf2ee4ed88f5f3679f4c57b95"
                                                                          data-text="환불 규정"
                                                                          className={cx("footer__info__link")}>환불 규정</a>
                        </li>
                        <li className={cx("footer__info__list__item")}><a href="https://support.spartacodingclub.kr/" id="footer-channel-button"
                                                                          data-text="고객 문의"
                                                                          className={cx("footer__info__link")}>고객 문의</a>
                        </li>
                    </ul>
                </section>
                <section className={cx("footer__dropdown")}>
                    <h4 className={cx("footer__dropdown__title")} id="info_drop_down" onClick={toggleFooterDetail}>
                        팀스파르타(주) 사업자 정보
                    </h4>
                    {is_opened ? (
                        <dl className={cx("footer__dropdown__info")}>
                            <div className={cx("footer__dropdown__info__list")}>
                                <dt>대표자:</dt>
                                <dd>&nbsp;이범규</dd>
                            </div>
                            <div className={cx("footer__dropdown__info__divider")}></div>
                            <div className={cx("footer__dropdown__info__list")}>
                                <dt>사업자 등록번호:</dt>
                                <dd>&nbsp;783-86-01715</dd>
                            </div>
                            <div className={cx("footer__dropdown__info__divider")}></div>
                            <div className={cx("footer__dropdown__info__list")}>
                                <dt>통신판매업 신고번호:</dt>
                                <dd>&nbsp;2020-서울강남-02300</dd>
                            </div>
                            <div className={cx("footer__dropdown__info__divider")}></div>
                            <div className={cx("footer__dropdown__info__list")}>
                                <dt>평생교육시설 신고번호:</dt>
                                <dd>&nbsp;제 661호</dd>
                            </div>
                            <div className={cx("footer__dropdown__info__list")}>
                                <dt>주소:</dt>
                                <dd>&nbsp;서울특별시 강남구 테헤란로44길 8 12층</dd>
                            </div>
                            <div className={cx("footer__dropdown__info__divider")}></div>
                            <div className={cx("footer__dropdown__info__list")}>
                                <dt>이메일:</dt>
                                <dd>&nbsp;contact@teamsparta.co</dd>
                            </div>
                        </dl>) : null
                    }

                </section>
                <p className={cx("footer__copyright")}>Copyright ©2023 TEAMSPARTA. All rights reserved.</p>
            </div>
        </footer>
    );
}